export const chatGPTPageData = {
  seo: {
    title: 'Joy | Wedding Writer’s Block Assistant',
    content: 'We’ve created an AI assistant to inspire you in writing your toughest wedding-related wordage',
  },
  sections: {
    weddingWritersUnblocker: {
      title: 'Overcome<br /> Your Wedding<br /> Writer’s Block',
      body: 'We’ve created an AI assistant to inspire you in writing your toughest wedding-related wordage.',
      submitCTA: 'Inspire Me',
      submitCTAAgain: ' Again',
      footerText: 'From your wedding website to your registry, plan your forever better with Joy.',
      loadingText: 'Crafting some inspiration <br /> for happily ever after…',
      socialLabel: {
        instagram: 'ChatGPT Footer Instagram',
        pinterest: 'ChatGPT Footer Pinterest',
        facebook: 'ChatGPT Footer Facebook',
        linkedin: 'ChatGPT Footer Linkedin',
        twitter: 'ChatGPT Footer Twitter',
        twitterWithjoy: 'ChatGPT Footer Twitter Withjoy',
      },
    },
  },
} as const;
